<template>
    <div>
        <el-form ref="userForm" :model="userForm" :rules="userFormRules" labelWidth="80px" size="medium">
            <el-form-item label="账号：" prop="username">
                <el-input v-model="userForm.username" placeholder="请输入账号" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password" v-if="!userForm.id">
                <el-input v-model="userForm.password" placeholder="请输入密码" clearable show-password></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="realname">
                <el-input v-model="userForm.realname" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="用户角色" prop="role_id">
                <el-select v-model="userForm.role_id" placeholder="请选择用户角色" clearable>
                    <el-option
                        v-for="item in roles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否开启" prop='status'>
                <el-switch
                    v-model="userForm.status"
                    active-value="active"
                    inactive-value="unactive">
                </el-switch>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {roleList} from '@/utils/getData';

    export default {
        name: "userEdit",
        props:["userForm"],
        data(){
            return{
                userFormRules:{
                    username:[
                        {required:true,message:"请输入账户",trigger:"blur"}
                    ],
                    password:[
                        {required:true,message:"请输入密码",trigger:"blur"}
                    ],
                    realname:[
                        {required:true,message:"请输入姓名",trigger:"blur"}
                    ],
                    role_id:[
                        {required:true,message:"请选择用户角色",trigger:"change"}
                    ],
                },
                roles:[]//角色列表
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                const res = await roleList({status:"active"});
                if (res.code == 0) {
                    this.roles = res.data.rows;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>